export default __webpack_public_path__ + "static/media/hh-character-regular-neutral-speaking.3e69b5bb.mp4";